import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { EASE } from "@/components/motion/Motion";

export function CollapsibleSection({ title, subtitle, defaultOpen = true, open: ctrl, onOpenChange, actions, children, testId, className }) {
  const [own, setOwn] = useState(defaultOpen);
  const open = ctrl ?? own;
  const set = (v) => (onOpenChange ? onOpenChange(v) : setOwn(v));
  return (
    <section className={cn("panel", className)} data-testid={testId} data-open={open ? "true" : "false"}>
      <div className="flex items-center gap-3 px-5 py-4">
        <button type="button" onClick={() => set(!open)} aria-expanded={open} className="flex min-w-0 flex-1 items-center gap-2 text-left" data-testid={testId ? `${testId}-toggle` : undefined}>
          <motion.span animate={{ rotate: open ? 0 : -90 }} transition={{ duration: 0.18 }} className="text-ink-muted"><ChevronDown size={16} aria-hidden="true" /></motion.span>
          <span className="min-w-0"><span className="block text-base font-semibold text-ink">{title}</span>{subtitle && <span className="block text-xs text-ink-muted">{subtitle}</span>}</span>
        </button>
        {actions}
      </div>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.24, ease: EASE }} className="overflow-hidden">
            <div className="px-5 pb-5">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
